export default function wwwRedirect(to, from, next) {
  if (window.location.href.includes('www.icreat.cat')) {
    window.location.href = `https://www.icreat.cat`
    return
  }
  next()
}
// https://portal.icrea.cat/intranet/www.icreat.cat